import * as reducers from 'store/reducers';
import { connectRouter } from 'connected-react-router';

const combineReducers = (history, config) => {
  // add in the router reducer here
  config['router'] = connectRouter(history);

  const defaultState = Object.keys(config).reduce((a, key) => {
    a[key] = config[key](undefined, []);
    return a;
  }, {});
  return (state = defaultState, action) => {
    return Object.keys(config).reduce((state, key) => {
      const reducer = config[key];
      const previousState = state[key];
      const newValue = reducer(previousState, action);
      if (newValue === undefined) {
        throw new Error(
          `A reducer returned undefined when reducing key::"${key}"`
        );
      }
      state[key] = newValue;
      return { ...state };
    }, state);
  };
};

export const combinedReducers = history => combineReducers(history, reducers);
